import React, { useState, useEffect, useRef } from 'react';
import { isMobile } from 'react-device-detect';

const allData = [
  { key: '1', description: 'Inicio de Vigencia ASC' },
  { key: '2', description: 'Inicio de Vigencia DESC' },
  { key: '3', description: 'Fin de Vigencia ASC' },
  { key: '4', description: 'Fin de Vigencia DESC' },
  { key: '5', description: 'Fecha límite de pago ASC' },
  { key: '6', description: 'Fecha límite de pago DESC' },
  { key: '7', description: 'Grupo ASC' },
  { key: '8', description: 'Grupo DESC' },
  { key: '9', description: 'Subgrupo ASC' },
  { key: '10', description: 'Subgrupo DESC' },
  { key: '11', description: 'Importe ASC' },
  { key: '12', description: 'Importe DESC' },
];

const DropdownOrder = ({ onOrderChange, text = 'Ordenar', type }) => {
  const [selectedOption, setSelectedOption] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const data = type === 'referenced_payments'
    ? allData.filter(item => !['Grupo ASC', 'Grupo DESC', 'Subgrupo ASC', 'Subgrupo DESC'].includes(item.description))
    : allData;

  useEffect(() => {
    const savedOption = localStorage.getItem('selectedOrderOption');
    setSelectedOption(savedOption && savedOption !== 'null' ? savedOption : 'Predeterminado');
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  const handleSelect = (value) => {
    setSelectedOption(value);
    setIsOpen(false);
    if (value === 'Predeterminado') {
      localStorage.removeItem('selectedOrderOption');
    } else {
      localStorage.setItem('selectedOrderOption', value);
    }
    applyOrderChange(value);
  };

  const applyOrderChange = (selectedDescription) => {
    let order_by = '';
    let order_dir = '';

    switch (selectedDescription) {
      case 'Importe ASC':
        order_by = 'total';
        order_dir = 'asc';
        break;
      case 'Importe DESC':
        order_by = 'total';
        order_dir = 'desc';
        break;
      case 'Subgrupo ASC':
        order_by = 'subgroup_id';
        order_dir = 'asc';
        break;
      case 'Subgrupo DESC':
        order_by = 'subgroup_id';
        order_dir = 'desc';
        break;
      case 'Grupo ASC':
        order_by = 'group_id';
        order_dir = 'asc';
        break;
      case 'Grupo DESC':
        order_by = 'group_id';
        order_dir = 'desc';
        break;
      case 'Inicio de Vigencia ASC':
        order_by = 'issue_date';
        order_dir = 'asc';
        break;
      case 'Inicio de Vigencia DESC':
        order_by = 'issue_date';
        order_dir = 'desc';
        break;
      case 'Fin de Vigencia ASC':
        order_by = 'due_date';
        order_dir = 'asc';
        break;
      case 'Fin de Vigencia DESC':
        order_by = 'due_date';
        order_dir = 'desc';
        break;
      case 'Fecha límite de pago ASC':
        order_by = 'extension_date';
        order_dir = 'asc';
        break;
      case 'Fecha límite de pago DESC':
        order_by = 'extension_date';
        order_dir = 'desc';
        break;
      case 'Predeterminado':
      default:
        order_by = '';
        order_dir = '';
        break;
    }

    onOrderChange({ order_by, order_dir });
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const displayText = `Ordenar por: ${selectedOption}` || `Seleccionar ${text}`;

  return (
    <div ref={dropdownRef} style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
      <div
        onClick={toggleDropdown}
        style={{
          backgroundColor: '#E6FAEF',
          color: '#00AEC7',
          minHeight: '40px',
          width: isMobile ? '100%' : '193px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          borderRadius: '5px',
          fontFamily: 'Sura Sans',
          textAlign: 'center',
          padding: isMobile ? '5px 4px' : '0',
          lineHeight: isMobile ? '120%' : '1.6'
        }}
      >
        {displayText}
      </div>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: '0',
            width: '100%',
            maxHeight: '500px',
            overflowY: 'auto',
            backgroundColor: '#FFFFFF',
            border: '1px solid #ccc',
            borderRadius: '5px',
            zIndex: 1000,
          }}
        >
          <form>
            <div
              onClick={() => handleSelect('Predeterminado')}
              style={{
                cursor: 'pointer',
                padding: '8px',
                display: 'flex',
                fontFamily: 'Sura Sans',
                alignItems: 'center',
                transition: 'background-color 0.2s, box-shadow 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.boxShadow = '0px 4px 8px rgba(0, 0, 0, 0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <input
                type="radio"
                name="order"
                value="Predeterminado"
                checked={selectedOption === 'Predeterminado'}
                onChange={() => handleSelect('Predeterminado')}
                style={{ marginRight: '8px' }}
              />
              Predeterminado
            </div>
            {data.map((item) => (
              <div
                key={item.key}
                onClick={() => handleSelect(item.description)}
                style={{
                  cursor: 'pointer',
                  padding: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  transition: 'background-color 0.2s, box-shadow 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f0f0f0';
                  e.currentTarget.style.boxShadow = '0px 4px 8px rgba(0, 0, 0, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <input
                  type="radio"
                  name="order"
                  value={item.description}
                  checked={selectedOption === item.description}
                  onChange={() => handleSelect(item.description)}
                  style={{ marginRight: '8px' }}
                />
                {item.description}
              </div>
            ))}
          </form>
        </div>
      )}
    </div>
  );
};

export default DropdownOrder;



// WEBPACK FOOTER //
// ./src/containers/agent/Tabs/Payments/DropdownOrder.js